module.exports = __webpack_public_path__ + "img/ic_16_close.43680392.svg";